import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { AuthGuard } from '../tools/auth.guard';


const routes: Routes = [
  {
    path: 'dashboard',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '',                 component:  WelcomeComponent },
      {
        path: 'services',
        loadChildren: () => import('../assabil-services/assabil-services.module').then(m => m.AssabilServicesModule)
      },
      {
        path: 'packing',
        loadChildren: () => import('../assabil-packing/assabil-packing.module').then(m => m.AssabilPackingModule)
      },
      {
        path: 'sales',
        loadChildren: () => import('../assabil-sales/assabil-sales.module').then(m => m.AssabilSalesModule)
      }
    ]
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
